export const walletEntryOutgoing = entry => entry.tx_type === 'WITHDRAW' || (entry.tx_type === 'TRANSFER' && Number(entry.amount) < 0);
export const walletEntryLabel = entry => entry.tx_type === 'TRANSFER' ? (Number(entry.amount) < 0 ? '지갑 전송' : '지갑 수신') : entry.tx_type === 'WITHDRAW' ? '출금' : '입금';
